import { EnvironmentTargetInterface } from '@environments/assets/environment-target.interface';

export const distributionApiTargets: EnvironmentTargetInterface = {
  production: {
    baseUrl: 'https://api.distribusjon.fagforbundet.no',
  },
  staging: {
    baseUrl: 'https://api.distribusjon.fagforbundet.dev',
  },
};
